import { Input } from "@/projects/NPS/Stepper/common/input";
import { Button } from "@/projects/NPS/Stepper/common/button";

export function Footer() {
  return (
    <footer className="w-full overflow-hidden bg-[#0A344A] font-sans text-white">
      <div className="border-b border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 py-12 lg:px-16">
          <div className="flex flex-col items-center justify-between gap-6 rounded-2xl bg-[linear-gradient(to_right,rgba(29,171,145,0.2),rgba(23,175,155,0.2))] p-8 lg:flex-row">
            <div className="text-center lg:text-left">
              <h3 className="font-display mb-1 text-2xl font-bold">
                Stay Updated
              </h3>
              <p className="text-white/70">
                Get the latest investment opportunities and market insights
              </p>
            </div>

            <div className="flex w-full gap-3 lg:w-auto">
              <Input
                type="email"
                placeholder="Enter your email"
                className="h-12 flex-1 rounded-xl border border-white/20 bg-white/10 px-4 text-sm text-white placeholder-white/90 outline-none lg:w-80"
              />

              <Button
                variant="default"
                className="flex h-12 items-center gap-2 rounded-xl bg-white px-6 font-bold text-[#0A344A] transition hover:bg-white/90"
              >
                Subscribe
                <svg
                  className="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="m22 2-7 20-4-9-9-4Z" />
                  <path d="M22 2 11 13" />
                </svg>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto flex w-full items-center justify-center px-6 py-12 md:px-8 md:py-16 lg:px-16">
        <div className="grid grid-cols-1 gap-20 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <img
              src="/assets/NPSLogo.png"
              alt="NPS Logo"
              className="mb-6 h-10"
            />

            <p className="mb-6 max-w-md font-nunito text-sm leading-relaxed text-white/70">
              Your trusted digital wealth platform for IPOs, Bonds, Fixed
              Deposits, and NPS investments. Start your investment journey with
              us today.
            </p>

            <div className="mb-6 flex flex-col gap-4">
              <div className="flex gap-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2C15.87 2 19 5.13 19 9C19 14.25 12 22 12 22C12 22 5 14.25 5 9C5 5.13 8.13 2 12 2ZM7 9C7 11.85 9.92 16.21 12 18.88C14.12 16.19 17 11.88 17 9C17 6.24 14.76 4 12 4C9.24 4 7 6.24 7 9ZM12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9C14.5 10.3807 13.3807 11.5 12 11.5Z"
                    fill="#1DAB91"
                  />
                </svg>
                <p className="mb-4 max-w-xs text-wrap break-words font-nunito text-[14px] font-normal leading-relaxed text-[#EAEAEA]">
                  36, Third floor, Palm spring complex, Ellisbridge,
                  Ahmedabad-380006, Gujarat
                </p>
              </div>
              <div className="flex items-center gap-4 text-[#D1E3EA]">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
                      fill="#1DAB91"
                    />
                  </svg>
                </span>
                <span className="font-nunito text-[14px] font-normal leading-relaxed text-[#EAEAEA]">
                  fineaseresearchpvtltd@gmail.com
                </span>
              </div>
              <div className="flex items-center gap-4 text-[#D1E3EA]">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
                      fill="#1DAB91"
                    />
                  </svg>
                </span>{" "}
                <span className="font-nunito text-[14px] font-normal leading-relaxed text-[#EAEAEA]">
                  079-2666588
                </span>
              </div>
            </div>

            <div className="mt-4 flex gap-3 md:gap-4">
              <a
                href="https://www.facebook.com/TheFinEase"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-[rgba(141,198,63,0.30)] p-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/thefinease/"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-[rgba(141,198,63,0.3)] p-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    stroke="white"
                    strokeWidth="2"
                  />
                  <path
                    d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <line
                    x1="17.5"
                    y1="6.5"
                    x2="17.51"
                    y2="6.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </a>
              <a
                href="https://x.com/i/flow/login?redirect_after_login=%2FTheFinEase"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-[rgba(141,198,63,0.3)] p-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFyNoTpHmjFrwAAAZq-_C0I72H25d2vlt6ZHsqs-HCOpdFsHiJLFftUgtFxJGv7SmEreddGf0Tbbp5LcEM0hNoMNs1gBApE4-meHnm-lW-QnkYFERigaimERqoYamZK--38kkE=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fthefinease%2F"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-[rgba(141,198,63,0.3)] p-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <rect
                    x="2"
                    y="9"
                    width="4"
                    height="12"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="4"
                    cy="4"
                    r="2"
                    stroke="white"
                    strokeWidth="1.5"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display mb-4 font-nunito text-sm font-bold uppercase tracking-wide">
              Our Services
            </h4>
            <ul className="flex flex-col gap-3 font-nunito">
              <li>
                <a
                  href="#ipo"
                  className="text-white/70 transition hover:text-white"
                >
                  IPO
                </a>
              </li>
              <li>
                <a
                  href="#bonds"
                  className="text-white/70 transition hover:text-white"
                >
                  Bonds
                </a>
              </li>
              <li>
                <a
                  href="#fixed-deposits"
                  className="text-white/70 transition hover:text-white"
                >
                  Fixed Deposits
                </a>
              </li>
              <li>
                <a
                  href="#nps"
                  className="text-white/70 transition hover:text-white"
                >
                  NPS
                </a>
              </li>
              <li>
                <a
                  href="#calculators"
                  className="text-white/70 transition hover:text-white"
                >
                  Calculators
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display mb-4 font-nunito text-sm font-bold uppercase tracking-wide">
              Company
            </h4>
            <ul className="flex flex-col gap-3 font-nunito">
              <li>
                <a
                  href="#about"
                  className="text-white/70 transition hover:text-white"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#careers"
                  className="text-white/70 transition hover:text-white"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="#blog"
                  className="text-white/70 transition hover:text-white"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="#press"
                  className="text-white/70 transition hover:text-white"
                >
                  Press
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display mb-4 font-nunito text-sm font-bold uppercase tracking-wide">
              Legal
            </h4>
            <ul className="flex flex-col gap-3 font-nunito">
              <li>
                <a
                  href="#terms"
                  className="text-white/70 transition hover:text-white"
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href="#privacy"
                  className="text-white/70 transition hover:text-white"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#risk"
                  className="text-white/70 transition hover:text-white"
                >
                  Risk Disclosure
                </a>
              </li>
              <li>
                <a
                  href="#grievance"
                  className="text-white/70 transition hover:text-white"
                >
                  Grievance Redressal
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 py-6 lg:px-16">
          <div className="flex flex-col items-center justify-between gap-4 text-xs text-white/50 md:flex-row">
            <p className="text-center font-nunito md:text-left">
              FinEase Research Pvt. Ltd. is a SEBI registered investment
              advisor. Investments are subject to market risks. Please read all
              scheme related documents carefully before investing.
            </p>

            <div className="flex items-center gap-4 font-nunito">
              <span>SEBI Reg. No: INH000000XXX</span>
              <span>CIN: U67190GJ2020PTCXXXXXX</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full items-center justify-center bg-[#057170] py-4">
        <p className="font-nunito text-sm font-medium text-white/90">
          © 2025 FinEase Research Pvt. Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
